<section id="modal">
  <div class="headermodal">
    <div class="iconmodal">
      <icon
        icon="/assets/icons/xml.svg"
        width="40px"
        height="20px"
        (click)="download()"
      ></icon>
    </div>
    <div class="titlemodal">(Notas: {{xmls.length}}) - {{ title }}</div>
    <div class="iconmodalclose" mat-dialog-close></div>
  </div>
  <div class="bodyoccurrence">
    <billboard
      title="Erros Encontrados"
      height="auto"
    >
    <ul>
        <li *ngFor="let error of erros">
            {{error}}
        </li>
    </ul>
        
    </billboard>
    <billboard
      [title]="'Nota Fiscal -> ' + item.nrnf"
      height="auto"
      *ngFor="let item of xmls"
    >
      <div table="column">
        <labelinput
          *ngFor="let key of xml_keys(item)"
          [title]="label(key)"
          type="text"
          [(value)]="item[key]"
          widthlabel="189px"
          disabled
        ></labelinput>
      </div>
    </billboard>
  </div>
  <!-- <spinner *ngIf="loading">Carregando...</spinner> -->
</section>
